import { queryOptions, useQuery } from '@tanstack/react-query'
import { allHubsId } from '../../services/farmMapping/getFarms'
import getUsers from '../../services/ruutsApi/users/getUsers'
import { queryKeys } from './queryKeys'

// Shared by the declarative hook and the imperative ensureQueryData reader in useEventCreation,
// so both hit one cache entry instead of racing their own fetch.
export const hubUsersQueryOptions = (hubId: string | undefined) =>
  queryOptions({
    queryKey: queryKeys.hubUsers(hubId),
    queryFn: ({ signal }) =>
      getUsers({
        query: `user_metadata.hubId:${hubId} OR user_metadata.hubId:${allHubsId}`,
        signal,
      }),
  })

// Returns the list as the server sorted it: the "current user first" order depends on the
// logged-in viewer, so it belongs at the consumer, not in a cache shared across viewers.
export const useHubUsers = (hubId: string | undefined) =>
  useQuery({
    ...hubUsersQueryOptions(hubId),
    enabled: !!hubId,
  })
